import '@angular/compiler';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageAdminSubjectsComponent } from './page.admin.subjects/page.admin.subjects.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageSurveyInvalidComponent } from './page.survey.invalid/page.survey.invalid.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageAdminFormsItemComponent } from './page.admin.forms.item/page.admin.forms.item.component';
import { ComponentSurveyRendererComponent } from './component.survey.renderer/component.survey.renderer.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageSurveyDoneComponent } from './page.survey.done/page.survey.done.component';
import { PageAdminStatisticsComponent } from './page.admin.statistics/page.admin.statistics.component';
import { PageSurveyTakeComponent } from './page.survey.take/page.survey.take.component';
import { PageAdminResultsItemComponent } from './page.admin.results.item/page.admin.results.item.component';
import { PageAdminSubjectsItemComponent } from './page.admin.subjects.item/page.admin.subjects.item.component';
import { PageAdminResultsComponent } from './page.admin.results/page.admin.results.component';
import { PageAdminDashboardComponent } from './page.admin.dashboard/page.admin.dashboard.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { LayoutSurveyComponent } from './layout.survey/layout.survey.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';

const INDEX_PAGE = "admin/dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            }
        ]
    },
    {
        component: LayoutAdminComponent,
        "children": [
            {
                "path": "admin/subjects",
                component: PageAdminSubjectsComponent,
                "app_id": "page.admin.subjects"
            },
            {
                "path": "admin/subjects/:id/forms/:form_code",
                component: PageAdminFormsItemComponent,
                "app_id": "page.admin.forms.item"
            },
            {
                "path": "admin/statistics",
                component: PageAdminStatisticsComponent,
                "app_id": "page.admin.statistics"
            },
            {
                "path": "admin/results/:id",
                component: PageAdminResultsItemComponent,
                "app_id": "page.admin.results.item"
            },
            {
                "path": "admin/subjects/:id",
                component: PageAdminSubjectsItemComponent,
                "app_id": "page.admin.subjects.item"
            },
            {
                "path": "admin/results",
                component: PageAdminResultsComponent,
                "app_id": "page.admin.results"
            },
            {
                "path": "admin/dashboard",
                component: PageAdminDashboardComponent,
                "app_id": "page.admin.dashboard"
            }
        ]
    },
    {
        component: LayoutSurveyComponent,
        "children": [
            {
                "path": "s-invalid/:reason?",
                component: PageSurveyInvalidComponent,
                "app_id": "page.survey.invalid"
            },
            {
                "path": "s/:token/done",
                component: PageSurveyDoneComponent,
                "app_id": "page.survey.done"
            },
            {
                "path": "s/:token",
                component: PageSurveyTakeComponent,
                "app_id": "page.survey.take"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }